import { render, staticRenderFns } from "./account-balance-log.vue?vue&type=template&id=2a4d8bc4&scoped=true&"
import script from "./account-balance-log.vue?vue&type=script&lang=js&"
export * from "./account-balance-log.vue?vue&type=script&lang=js&"
import style0 from "./account-balance-log.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./account-balance-log.vue?vue&type=style&index=1&id=2a4d8bc4&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2a4d8bc4",
  null
  
)

export default component.exports